import Vue from "vue";
import Vuex from "vuex";
import storage from "../common/storage.js";

Vue.use(Vuex);

let store = new Vuex.Store({
    state: {
    },
    mutations: {
    }
});

export default store;



// WEBPACK FOOTER //
// ./src/vuex/store.js